import Box from '@mui/material/Box';

export type Tone = 'ok' | 'warn' | 'err' | 'neutral' | 'primary';

const PALETTE_KEY = {
  ok: 'success',
  warn: 'warning',
  err: 'error',
  neutral: 'neutral',
  primary: 'primary',
} as const;

export interface StatusChipProps {
  tone: Tone;
  label: string;
  /** Small 6px dot before the label (design default). */
  dot?: boolean;
  size?: 'small' | 'tag';
}

/** Design "Chip de statut": 24px, radius 8, tonal container + dot. `size="tag"` = 22px, radius 6, no dot. */
export function StatusChip({ tone, label, dot = true, size = 'small' }: StatusChipProps) {
  const key = PALETTE_KEY[tone];
  const tag = size === 'tag';
  return (
    <Box
      component="span"
      sx={(theme) => ({
        height: tag ? 22 : 24,
        px: tag ? 1 : undefined,
        paddingInlineStart: tag ? undefined : '8px',
        paddingInlineEnd: tag ? undefined : '10px',
        borderRadius: tag ? '6px' : '8px',
        bgcolor: theme.vars.palette[key].container,
        color: theme.vars.palette[key].onContainer,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: tag ? 11 : 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        lineHeight: 1,
      })}
    >
      {dot && !tag && (
        <Box component="span" sx={{ width: 6, height: 6, borderRadius: 3, bgcolor: 'currentColor' }} />
      )}
      {label}
    </Box>
  );
}
